{
  "aiCameraSettings": {
    "text": "5 seconds",
    "text2": "10 seconds",
    "text3": "30 seconds",
    "text4": "1 minute",
    "text5": "5 minutes",
    "text6": "10 minutes",
    "text7": "30 minutes",
    "text8": "1 hour",
    "text9": "3 hours",
    "text10": "6 hours",
    "text11": "1 day",
    "text12": "{{days}} days",
    "text13": "{{hours}} hours",
    "text14": "{{minutes}} minutes",
    "text15": "{{normalized}} seconds"
  },
  "aiDetectionUtils": {
    "text": "Custom",
    "text2": "Preset",
    "aiDetectionQuotaBlockedMessage": "Detection has stopped because the detection limit was reached. To resume, wait for next month's renewal or change the plan.",
    "aiDetectionQuotaPartiallyBlockedMessage": "Some cameras can't run detection because they reached the detection limit.",
    "text3": "Moved",
    "text4": "Stopped",
    "text5": "Limit reached",
    "text6": "Partially limited",
    "text7": "Detecting",
    "text8": "People count",
    "text9": "Helmet",
    "text10": "Intrusion",
    "text11": "Meter",
    "text14": "People count: {{value}}",
    "text15": "Value: {{value}}{{unit}}",
    "text16": "Value: {{value}}",
    "text17": "Ongoing",
    "text18": "Detection started",
    "text19": "Detection ended",
    "text20": "Detection",
    "text21": "People count: {{personCount}}",
    "text22": "People count: {{result}}",
    "text23": "Helmet: {{helmet}}",
    "text24": "Custom detection",
    "text25": "No helmet",
    "text26": "or more",
    "text27": "exceeded",
    "text28": "Intrusion detection region: {{roiId}}",
    "text29": "Detects intrusion into the specified region",
    "text30": "{{threshold}} people",
    "text31": "Person detection",
    "text32": "Helmet detection",
    "text33": "Intrusion detection",
    "text34": "Preset detection",
    "text35": "{{cameraName}} (limit: {{perCameraLimit}})",
    "text36": "The number of {{categoryLabel}} detections has reached the camera limit. Cameras at the limit: {{value}}",
    "aiDetectionLimitExceededMessage": "This camera has reached the maximum number of detections it can run. Stop detections that aren't needed, then add a new one.",
    "text37": "{{areaName}} · All cameras",
    "text38": "All cameras",
    "text39": "{{areaName}} · {{targetCount}} cameras",
    "text40": "All cameras in {{areaName}}",
    "text41": "{{targetCount}} cameras in {{areaName}}",
    "text42": "{{targetCount}} cameras",
    "text43": "{{value}} detection",
    "text44": "On",
    "text45": "Notify on first detection only",
    "text46": "Notify every hour",
    "text47": "Notify daily at {{deliveryTime}}",
    "text48": "Notify once a day",
    "text49": "{{start}} – No end date",
    "text50": "All day",
    "text51": "5 seconds",
    "text52": "{{seconds}} seconds",
    "text53": "{{value}} minutes",
    "text54": "{{value}} hours",
    "text55": "Once a day",
    "label": "Target cameras",
    "label2": "Notifications",
    "label3": "Notification timing",
    "label4": "Detection period",
    "label5": "Detection hours",
    "label6": "Detection frequency",
    "text56": "Enter a notification email address.",
    "text57": "The notification email address format is invalid."
  },
  "aiDetectionWeeklySchedule": {
    "label": "Mon",
    "label2": "Tue",
    "label3": "Wed",
    "label4": "Thu",
    "label5": "Fri",
    "label6": "Sat",
    "label7": "Sun",
    "text": "No schedule set"
  },
  "llmText": {
    "shopliftingTargetLabel": "Shoplifting target",
    "shopliftingActionLabel": "Shoplifting behavior",
    "text11": "None",
    "text12": "Cannot be determined",
    "text13": "Store merchandise",
    "text14": "A person was observed moving merchandise into a bag, pocket, or clothing, after which it was no longer visible.",
    "text15": "No relevant behavior was observed.",
    "text16": "The movements of the merchandise and the person couldn't be confirmed from the video alone (cannot be determined)."
  }
}
